import { cn } from "@/lib/utils";
import { FlameIcon, InfoIcon, VipCheckIcon } from "@/components/fun-ui/icons";
import * as Icons from "@/components/fun-ui/icons";
import { Tip } from "@/components/fun-ui/Tip";
import { memberLabelClassName } from "../fun-ui/MemberLabel";
import { PaymentRightsItem } from "@/stores/slices/commonSlice";


export interface PaymentRightsListProps extends React.HTMLAttributes<HTMLUListElement> {
  items: PaymentRightsItem[];
  scale?: number;
  columns?: number;
}

const PAYMENT_RIGHTS_TIP_CONTENT_CLASS =
  "max-w-[min(280px,85vw)] whitespace-normal break-words px-3 py-2 text-xs font-normal leading-relaxed text-primary-foreground";
const PAYMENT_RIGHTS_TIP_ICON_COLOR = "hsl(var(--foreground))";

export const PaymentRightsList = ({
  items = [],
  className,
  scale = 1,
  style = {},
  columns = 1,
}: PaymentRightsListProps) => {
  return (
    <ul
      className={cn(
        "grid",
        className
      )}
      style={{
        columnGap: `${10 * scale}px`,
        rowGap: `${20 * scale}px`,
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        ...style
      }}
    >
      {
        items?.map(({
          label,
          tip,
          badge,
          icon = 'VipCheckIcon',
          isDesc,
          isNew,
          linkto,
        }, index) => {
          const Icon = icon ? Icons[icon] : null;
          return (
            <li
              key={index}
              className="flex flex-nowrap items-center"
              style={{
                fontSize: `${14 * scale}px`,
                lineHeight: `${20 * scale}px`,
              }}
            >
              {
                (!Icon || isDesc === true) ? null : (
                  <Icon className="text-[#7a5f44]" size={14 * scale} />
                )
              }
              <span
                className="whitespace-nowrap"
                style={{
                  ...({
                    marginLeft: `${8 * scale}px`,
                  }),
                  ...(
                    isDesc === true ? {
                      marginLeft: 0
                    } : {}
                  )
                }}
              >
                {
                  linkto ? (
                    <a
                      className={memberLabelClassName}
                      href={linkto}
                      target="_blank"
                    >{label}</a>
                  ) : label
                }
              </span>
              {
                tip ? (
                  <span
                    className="flex shrink-0 items-center"
                    style={{
                      marginLeft: `${4 * scale}px`,
                    }}
                  >
                    <Tip
                      label={tip}
                      truncate={false}
                      className="cursor-help"
                      contentClassName={PAYMENT_RIGHTS_TIP_CONTENT_CLASS}
                    >
                      <InfoIcon
                        size={14 * scale}
                        color={PAYMENT_RIGHTS_TIP_ICON_COLOR}
                        className="cursor-help"
                      />
                    </Tip>
                  </span>
                ) : null
              }
              {
                badge ? (
                  <span
                    className="shrink-0 rounded-full border border-[#372E23] truncate max-w-fit"
                    style={{
                      fontSize: `${10 * scale}px`,
                      lineHeight: `${12 * scale}px`,
                      padding: `${2 * scale}px ${4 * scale}px`,
                      marginLeft: `${8 * scale}px`,
                    }}
                  >{badge}</span>
                ) : null
              }
              {
                isNew ? (
                  <span
                    className="shrink-0 rounded-full border border-destructive text-destructive truncate max-w-fit flex items-center"
                    style={{
                      fontSize: `${10 * scale}px`,
                      lineHeight: `${12 * scale}px`,
                      padding: `${2 * scale}px ${4 * scale}px`,
                      marginLeft: `${8 * scale}px`,
                    }}
                  >
                    <FlameIcon size={10 * scale} />
                    <span style={{
                      paddingLeft: `${2 * scale}px`
                    }}
                    >New</span>
                  </span>
                ) : null
              }
            </li>
          )
        })
      }
    </ul>
  )
}
